import { render, staticRenderFns } from "./ProgramaHero.vue?vue&type=template&id=a4384c52&scoped=true"
import script from "./ProgramaHero.vue?vue&type=script&lang=js"
export * from "./ProgramaHero.vue?vue&type=script&lang=js"
import style0 from "./ProgramaHero.vue?vue&type=style&index=0&id=a4384c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4384c52",
  null
  
)

export default component.exports